module.exports = __webpack_public_path__ + "components/flag/static/square/dg-9d67d7cb98dd994f30c864f1c66e58e3.svg";